const { size } = require('../size')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * Format form alternatives array
 * @param {array} values
 * @returns {array|undefined}
 */
function formatFormAlternatives (values) {
  if (!size(values)) return []

  const output = []
  values.forEach(item => {
    output.push({
      value: item.id,
      label: item.value,
      ...(item.category ? { category: item.category } : {})
    })
  })

  return output
}

module.exports = { formatFormAlternatives }
